import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'SET_USER',
  initialState: null,
  reducers: {
    setUser: (state, action) => {
      return action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;
export const userReducer = userSlice.reducer;
